export default "__VITE_ASSET__Pb5$pG3z__"